import { TemplateExtended } from '@distribute/shared/api-types/templates';
import {
  TemplateCreationPhase,
  TemplateSharingAccess,
} from '@distribute/shared/types';

import { FILTER_TEMPLATE_ITEMS } from '../config';

import { ALL_OWNERS } from '../../../features/team-members'; // Fix that

export const filterByPersonalTemplates = (templates: TemplateExtended[]) =>
  templates.filter(
    (template) =>
      template.sharingAccess === TemplateSharingAccess.PERSONAL &&
      template.creationPhase === TemplateCreationPhase.READY_TO_USE &&
      template.isOwner
  );

export const filterByDraftTemplates = (templates: TemplateExtended[]) =>
  templates.filter(
    (template) =>
      template.creationPhase === TemplateCreationPhase.DRAFT && template.isOwner
  );

export const filterByTeamTemplates = (templates: TemplateExtended[]) =>
  templates.filter(
    (template) =>
      template.sharingAccess === TemplateSharingAccess.TEAM &&
      template.creationPhase === TemplateCreationPhase.READY_TO_USE &&
      !template.isDistribute
  );

export const getFilteredTemplatesByOwner = (
  templates: TemplateExtended[],
  ownerId: string
) => {
  return ownerId === ALL_OWNERS
    ? templates
    : templates.filter((t) => t.owner?.id === ownerId);
};

export const getFilteredTemplatesByType = (
  templates: TemplateExtended[],
  filter: keyof typeof FILTER_TEMPLATE_ITEMS
) => {
  if (filter === 'onePage') {
    return templates.filter(({ isSinglePage }) => isSinglePage);
  }

  if (filter === 'multiPage') {
    return templates.filter(({ isSinglePage }) => !isSinglePage);
  }

  return templates;
};
